import { defineMessages } from 'react-intl';

export default defineMessages({
  contactAdmin: {
    description: 'Tooltip text asking to contact admin for permissions',
    defaultMessage: 'Please contact your admin to access this setting',
    id: 'rb/kCU',
  },
  importOrders: {
    description: 'settings.importOrders',
    defaultMessage: 'Import Orders',
    id: 'zasyWs',
  },
  storeSetup: {
    description: 'Link to store setup from settings home page',
    defaultMessage: 'Store Setup',
    id: 'o8kZXk',
  },
  storeSetupBlurb: {
    description: 'settings.storeSetup.blurb',
    defaultMessage: 'Connect your stores and marketplaces so ShipStation can import your orders',
    id: 'aeUyBl',
  },
  automationRules: {
    description: 'settings.addAutomationRules',
    defaultMessage: 'Add Automation Rules',
    id: '1EQuRG',
  },
  automationRulesBlurb: {
    description: 'settings.automationRules.blurb',
    defaultMessage: 'Upon order import, performs tasks based on criteria (weight, order value, etc.)',
    id: 'dYu70z',
  },
  printing: {
    description: 'settings.printing',
    defaultMessage: 'Printing',
    id: 'iuHzNu',
  },
  documentOptions: {
    description: 'settings.documentOptions',
    defaultMessage: 'Document Options',
    id: 'sE/gXa',
  },
  documentOptionsBlurb: {
    description: 'settings.documentOptions.blurb',
    defaultMessage: 'Choose documents and formats such as labels, pick lists, and packing slips',
    id: 'ePX56Z',
  },
  connect: {
    description: 'settings.connect',
    defaultMessage: 'ShipStation Connect',
    id: '8l2wMD',
  },
  connectBlurb: {
    description: 'settings.connect.blurb',
    defaultMessage: 'The best way to connect to printers and USB scales',
    id: 'EJhk81',
  },
  labels: {
    description: 'settings.labels',
    defaultMessage: 'Labels',
    id: 'K2QP6B',
  },
  carriers: {
    description: 'settings.carriers',
    defaultMessage: 'Shipping Carriers',
    id: 'Qp/HqA',
  },
  carriersBlurb: {
    description: 'settings.carriers.blurb',
    defaultMessage: 'Create or connect accounts and buy USPS postage',
    id: 'WvqoEm',
  },
  carriersBlurbNonUSPS: {
    description: 'shipping carriers settings description when USPS carrier is not available',
    defaultMessage: 'Create, connect, or manage accounts',
    id: 'N2fuzZ',
  },
  warehouses: {
    description: 'settings.warehouses',
    defaultMessage: 'Ship From Locations',
    id: 'gOHwdO',
  },
  warehousesBlurb: {
    description: 'settings.warehouses.blurb',
    defaultMessage: 'Create and manage your "Ship From" and "Return To" addresses',
    id: 'GYmuqj',
  },
  packageTypesAndServices: {
    description: 'settings.packageTypesAndServices',
    defaultMessage: 'Package Types and Shipping Services',
    id: 'NSPfYB',
  },
  packageTypesAndServicesBlurb: {
    description: 'settings.packageTypesAndServices.blurb',
    defaultMessage: 'Customize the list of package types available to your users',
    id: 'Bs4Zpe',
  },
  customer: {
    description: 'settings.customer',
    defaultMessage: 'Customer Communication',
    id: 'rtQwgI',
  },
  emailTemplates: {
    description: 'settings.emailTemplates',
    defaultMessage: 'Email Templates',
    id: '5EGN1m',
  },
  emailTemplatesBlurb: {
    description: 'settings.emailTemplatesBlurb.blurb',
    defaultMessage: 'Customize shipment and delivery notifications sent to your shoppers',
    id: 'kv1CHQ',
  },
  packingSlips: {
    description: 'settings.packingSlips',
    defaultMessage: 'Packing Slips',
    id: 'IPW+OC',
  },
  packingSlipsBlurb: {
    description: 'settings.packingSlips.blurb',
    defaultMessage: 'This HTML template editor is available for Silver plans and above, incl. trials',
    id: 'NuchsB',
  },
  brandedTracking: {
    description: 'settings.brandedTracking',
    defaultMessage: 'Branded Customer Pages',
    id: 'I3ChN4',
  },
  brandedTrackingBlurb: {
    description: 'settings.brandedTracking.blurb',
    defaultMessage: 'Provide a branded tracking experience for your customers',
    id: 'rTN083',
  },
  account: {
    description: 'settings.account',
    defaultMessage: 'Account',
    id: 'tncUgG',
  },
  users: {
    description: 'settings.users',
    defaultMessage: 'Users',
    id: 'RZlRII',
  },
  usersBlurb: {
    description: 'settings.usersBlurb',
    defaultMessage: 'Configure restrictions and permissions for all your users',
    id: 'MVUZxF',
  },
  subscriptionBlurb: {
    description: 'settings.subscriptionBlurb',
    defaultMessage: 'Update your billing information or your ShipStation plan',
    id: 'mXeJI6',
  },
  changePassword: {
    description: 'settings.changePassword',
    defaultMessage: 'Change Password',
    id: '966oFP',
  },
  onboard: {
    description: 'title for settings section for onboard page',
    defaultMessage: 'Onboard',
    id: 'VtvwMs',
  },
  onboardingGuide: {
    description: 'link text for going to onboarding',
    defaultMessage: 'Onboarding Guide',
    id: 'G5UNpp',
  },
  onboardingGuideDescription: {
    description: 'description test for the onboarding guide',
    defaultMessage: 'Use the Onboarding Guide to quickly complete the necessary steps to import orders and create labels.',
    id: 'eU1AnP',
  },
  showConfirmationBodyHeader: {
    description: 'header in the body of the modal for alerting the user that we will make a change to their settings',
    defaultMessage: "You have the Onboard Guide hidden. We'll make it visible again.",
    id: 'SQGAuC',
  },
  showConfirmationBody: {
    description: 'paragraph in the modal for confirming with the user that we will change the visibility of the onboard page',
    defaultMessage:
      'Click Continue to show the Onboarding Guide and add the Onboard option back to your account navigation bar. If you want to keep the Onboarding Guide hidden, click cancel.',
    id: 'MEjYL2',
  },
  showOnboardConfirmationHeader: {
    description: 'modal header for confirming the visibility switch of the onboarding page',
    defaultMessage: 'Show Onboarding Guide',
    id: 'FQBRmg',
  },
  errorTitle: {
    description: 'title for the notification shown when something went wrong with showing onboarding page',
    defaultMessage: 'Something went wrong',
    id: 'Doc3NG',
  },
  errorContent: {
    description: 'content for message to user when something went wrong.',
    defaultMessage: 'Unable to show the onboard page, please try again.',
    id: 'RG1hvU',
  },
  shippingSuppliesTitle: {
    description: 'title for the shipping supplies section in settings',
    defaultMessage: 'Shipping & Printing Supplies',
    id: '3bMRTs',
  },
  shippingSuppliesLinkText: {
    description: 'link text for going to shipping supplies store',
    defaultMessage: 'Supplies Store',
    id: 'YGdQXD',
  },
  shippingSuppliesDescription: {
    description: 'description text for the shipping supplies store',
    defaultMessage:
      'Shop the Supplies Store for all your shipping essentials, including label printers, shipping scales, and packing materials.',
    id: 'DPhBms',
  },
  addOnMarketplace: {
    description: 'settings page for shopping for add-ons',
    defaultMessage: 'Add-Ons',
    id: 'eHEwAc',
  },
  addOnLinkText: {
    description: 'link text for navigating to the Add-On Marketplace',
    defaultMessage: 'View all available add-ons',
    id: 'FnNQLP',
  },
  addOnDescription: {
    description: 'description text for the add on section',
    defaultMessage: "Add-Ons extend ShipStation's capabilities to accommodate specialized workflows.",
    id: '2LLldj',
  },
});
